import { MODEL_VERSION } from '@/app/constants';
import type { ModelVersion, TaskParams } from '@/app/types';
import type { Video2ExtendFormParams } from '@/app/utils';
import { convertImagePromptsFormToAPI } from '@/app/utils';
import { isHevcSupported } from '@/app/utils/client';

export const convertVideo2extend = (formParams: Video2ExtendFormParams, modelVersion: ModelVersion): TaskParams => {
  // 通用逻辑
  const textInput = formParams.textPrompt ? [{ type: 'text' as const, content: formParams.textPrompt }] : [];

  const imageInput = convertImagePromptsFormToAPI(formParams.imagePrompts.map((p) => p?.prompt ?? null));

  const videoPrompt = formParams.videoPrompt;

  const videoInput = {
    type: 'video' as const,
    content: videoPrompt.content,
    extend2video: {
      from: videoPrompt.from,
      to: videoPrompt.to,
      duration: videoPrompt.duration,
    },
  };

  const prompts = [...textInput, ...imageInput, videoInput];

  const settings: TaskParams['settings'] = {
    ...formParams.settings,
    codec: isHevcSupported() ? 'h265' : 'h264',
    model_version: modelVersion || MODEL_VERSION.Q2,
  };

  return {
    input: {
      prompts,
      enhance: true,
    },
    type: imageInput.filter(Boolean).length > 0 ? 'video2extail' : 'video2extend',
    settings,
  };
};
